import React, { useState, useEffect } from "react";
import styles from "./Register.module.css";
import Button from "../../component/Button";
import { useNavigate } from "react-router-dom";
import { fetchDataFromApi, sendDataToApi } from "../../api/Api";
import FirstImage from "../../assets/images/LogoSBM-White.svg";
import secondImage from "../../assets/images/LogoMohua.svg"
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
} from "mdb-react-ui-kit";

const Register = () => {
  const navigate = useNavigate();
  const [mobileError, setMobileError] = useState("");

  const [mobile, setMobile] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [centredModal, setCentredModal] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const toggleShow = () => {
    setCentredModal(!centredModal);
  };

  const generateOtp = async (mobile) => {
    sendDataToApi(`generate-otp/${mobile}`, {}).then((res) => {
      if (res.status) {
        navigate("/selectlanguage", { state: { mobile } });
      } else {
        setErrorMsg(res?.message)
        toggleShow();
      }
    });
  };

  const handleValidateButton = async () => {
    if (!isValidPhoneNumber(mobile)) {
      setMobileError("Enter a valid 10-digit mobile number");
      return;
    }

    fetchDataFromApi("phoneNumberExists/" + mobile)
      .then(async (res) => {
        if (res.status) {
          localStorage.setItem("login", true);
          localStorage.setItem("token", res.data);
          await generateOtp(mobile);
        } else {
          setErrorMsg(res?.message);
          toggleShow();
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  const isValidPhoneNumber = (phone) => {
    return /^[6-9]\d{9}$/.test(phone);
  };

  const handleMobile = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // digits only
    setMobile(value);
    if (value.length === 0) {
      setMobileError("");
    } else if (!isValidPhoneNumber(value)) {
      setMobileError("Enter a valid 10-digit mobile number");
    } else {
      setMobileError("");
    }
  };


  const onButtonClick = () => {
    navigate("/avatarlogin");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [minutes, seconds]);

  return (
    <>
      <div className="container">
      <div className={styles.headerBar}>
  <div className={styles.headerInner}>
    <img src={secondImage} alt="leftLogo" className={styles.headerLogoLeft} />

    <div className={styles.headerTitle}>WELCOME</div>

    <img src={FirstImage} alt="rightLogo" className={styles.headerLogoRight} />
  </div>

  <div className={styles.subHeader}>
    Use Mobile Number and OTP
  </div>
</div>

        <div className={styles.mainWrapper}>
          <div className={styles.topWrapper}>
          
            <div className={styles.otpWrapper}>
              <div className={styles.otpDescWrapper}>
                <p>Share your mobile number with us and we will send you an OTP to verify your mobile number.</p>
              </div>
            </div>
            <div className={styles.form}>
              <>
                <div className={styles.mobileInputFieldWrapper}>
                  <label htmlFor="mobile" className={styles.inputFieldLabel}>
                    Mobile Number
                  </label>

                  <input
                    value={mobile}
                    type="tel"
                    className={styles.mobileInputField}
                    id="mobile"
                    onChange={handleMobile}
                    maxLength={10}
                  />

                 

                </div>
                {mobileError && (
                    <p className={styles.errorText}>{mobileError}</p>
                  )}
                <div className={styles.resendWrapper}></div>
              </>
              <>


                <div className={styles.bottomButtonWrapper} disabled={false}>
                  <Button text="SEND OTP" className={styles.validateButton}
                    type="submit"

                    disabled={!isValidPhoneNumber(mobile) || seconds !== 0}

                    onClick={handleValidateButton} />
                </div>
              </>
            </div>
            {/* Footer */}
          </div>
        </div>
        <div className={styles.footerStrip}>
          Powered by Swachh Bharat Mission Urban
        </div>
      </div>

      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog className={styles.modalDialog} centered>
          <MDBModalContent className={styles.popupContent}>
            <MDBModalBody>
              <div className={styles.popupMainWrapper}>
                <div className={styles.popupHeaderWrapper}>
                  <p className={styles.popupHeader}>Alert Message</p>
                </div>
                <div className={styles.popupbodyWrapper}>
                  <p className={styles.popupbody}>
                    {errorMsg}
                  </p>
                </div>
                <div>
                  <button
                    className={styles.popupCloseButton}
                    onClick={() => navigate("/")}
                  >
                    Close
                  </button>
                </div>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};

export default Register;
